import React from 'react'
import { connect } from 'react-redux'

class AutoresponseKeyword extends React.Component {
	render() {
		return (
			<div className="col-sm-12 py-4">
				<div className="d-flex">
                    <div className="flex-grow-1 mr-2" id={this.props.autoresponseKeyword.id ?? null}>
                        <h5>{__('Keyword/Phrase')}:</h5>
                        <div className="input-group feedback-form-control border mb-3 mt-3">
                            <input
                                type="text"
                                onChange={this.props.changeKeyword.bind(this)}
                                value={this.props.autoresponseKeyword.keyword}
                                name={`keyword_responses[${this.props.idx}][keyword]`}
                                required
                                className="input form-control"
                                placeholder={' '}
                            />
                        </div>

                        {this.props.autoresponseKeyword.keyword_error &&
                            <label className="text-danger">{this.props.autoresponseKeyword.keyword_error}</label>
                        }


                        <h5>{__('Auto-Response Message')}:</h5>
                        <div className="input-group feedback-form-control border mt-3">
							<textarea
                                onChange={this.props.changeResponse.bind(this)}
                                value={this.props.autoresponseKeyword.response}
                                name={`keyword_responses[${this.props.idx}][response]`}
                                required
                                className="input form-control placeholder-up"
                                placeholder={' '}
                            >

							</textarea>
                        </div>
                        {this.props.autoresponseKeyword.response_error &&
                            <label className="text-danger">{this.props.autoresponseKeyword.response_error}</label>
                        }
                        <div className="mt-2">
                            <input type="hidden"
                                name={`keyword_responses[${this.props.idx}][auto_resolve]`}
                                value="0"
                            />
                            <input
                                className="d-inline-block ml-1"
                                type="checkbox"
                                onChange={this.props.changeAutoResolve.bind(this)}
                                checked={!!this.props.autoresponseKeyword.auto_resolve}
                                name={`keyword_responses[${this.props.idx}][auto_resolve]`}
                                value="1"
                                id={`auto_resolve_${this.props.idx}`}
                            />
                            <label htmlFor={`auto_resolve_${this.props.idx}`} className="d-inline-block ml-2 mb-0">
                                {__('Auto-Resolve Feedback after Auto-Response message is sent')}
                            </label>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mb-4 justify-content-end justify-content-sm-center">
                        <a href="#" className="delete dark-grey-x" onClick={this.props.delete.bind(this)}><i
                            className="fas fa-times text-dark"></i></a>
                    </div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { state: state }
}

export default connect(mapStateToProps)(AutoresponseKeyword);
